import React, { Component } from 'react';
import * as firebase from 'firebase';
import '../App.css';
import '../view/css/Home.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";
import { SignupModal } from './SignupModal';
import {
    Button,
} from '@material-ui/core';
import { AFSignupModal } from './AFSignupModal';
import { NavBarGuest, NavBarAffiliate, NavBarUser } from '../view/NavBar';
import { ProfileSettings } from './ProfileSettings';
import Search from './Search';
import { VideoModal } from '../view/VideoModal';
import { Eventfeed } from './Feed.js'
import { Discovery } from './Discovery';
import { AffiliateView } from './AffiliateView';
import { AffiliateEvents } from './AffiliateEvents';
import { AffiliateGallery } from './AffiliateGallery';
import { CalendarPage } from './CalendarPage';

var type_1 = "";

function mainPage() {

    const scrollToBottom = () => window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth"
    })

    var firestore = firebase.firestore();
    var user = firebase.auth().currentUser;



    const runThis = () => {
        if (user) {
            const db = firestore.collection("Users").doc(user.email);
            const doc = db.get().then(function (doc) {
                if (doc.exists) {
                    // type_1 = doc.data().type;
                    console.log("HOME USER CHECK");
                    console.log(doc.data().type);
                } else {
                    console.log("NOTHING EXISTS");
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        }
        else {
            type_1 = "";
            console.log("this");
        }
    }




    return (
        <div className="Home">
            {runThis()}
            {type_1 == "" ? <NavBarGuest /> : type_1 == "Student" ? <NavBarUser /> : <NavBarAffiliate />}
            {console.log(type_1)}

            {/* {type_1 == "" ? <NavBarGuest /> : type_1 == "Student" ? <NavBarUser /> : <NavBarAffiliate />} */}

            {/* First Frame */}
            <section className="SectionOne">
                <div className="LogoWrapper">
                    <img src={process.env.PUBLIC_URL + '/digitalassets/logo800.png'} className="App-logo" alt="logo" />
                </div>
                <div className="CallToAction">
                    <h1 className="CatchTitle">Catch wind of your next circle</h1>
                    <p className="Subtitle">
                        Discover and connect with campus and student clubs, organizations, and communities at UC San Diego.
            </p>
                    <div className="MainButtons">
                        <div className="SignupBtnContainer">
                            <button className="SignupBtn" onClick={scrollToBottom}>Sign Up</button>
                        </div>
                        <div className="ExploreBtnContainer">
                            {/* <button href="/explore" className="ExploreBtn">Explore Orgs</button> */}
                            <Link to="/Explore" style={{ all: "unset", cursor: "default" }} className="TEST" ><button className="ExploreBtn">Explore Orgs</button></Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Transitioning Divider */}
            <section>
                <svg className="divider1" viewBox="0 0 1440 120" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1440 21.21V120H0V21.21C120 35.07 240 42 360 42s240-6.93 360-20.79c88.328-8.794 154.574-14.333 198.738-16.618A3120.562 3120.562 0 0 1 1080 .42c120 0 240 6.93 360 20.79z">
                    </path>
                </svg>
            </section>
            {/* Transitioning Divider */}

            {/* Second Frame */}
            <section className="SectionTwo">
                <h1 className="header">What We Do</h1>
                <div>
                    <p>
                        Breeze introduces a centralized platform that bridges the needs of students and campus affiliates alike.
          </p>
                    <p>
                        With Breeze, students are offered an easy-to-navigate interface that helps them find the organizations that best match their interests, and affiliates are offered tools and the platform to do just that.
          </p>
                    <p>
                        By connecting the two, breeze aims to cultivate an environment that promotes community involvement and engagement.
          </p>
                </div>
                <VideoModal />
            </section>

            {/* Transitioning Divider */}
            <section>
                <svg className="divider2" viewBox="0 0 1920 240" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0c62.028 23.301 207.726 31.062 355.345 10.956 194.93-26.548 329.274 58.551 412.36 95.275 113.991 50.379 161.026 36.177 242.491 47.604 81.464 11.428 80.28 30.32 167.409 35.339 99.802 5.746 258.527-51.115 385.457-10.565 156.954 50.136 300.814-6.06 356.938 1.225V240H0V0z">
                    </path>
                </svg>
            </section>
            {/* Transitioning Divider */}

            {/* Third Frame */}
            <section className="SectionThree">
                <div className="FeatureSpotlightText">
                    <h1 className="header">
                        Explore
                    </h1>
                    <p className="headerPara">
                        Get started by discovering affiliates through our search page! Here, you can search for specific keywords, filter by unique tags, or simply browse through the entire collection to find affiliates to add to your profile. 
                    </p>
                </div>
                <div className="SectionContent">
                    <img src="https://res.cloudinary.com/dyjbpwees/image/upload/v1607199993/breeze/Featured1.png" />
                </div>
            </section>

            {/* Transitioning Divider */}
            <section>
                <svg className="divider3" viewBox="0 0 1600 173" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1665.731 145.823c-115.382 81.947-257.301-50.789-507.113-94.011C854.859-.745 794.065 148.685 426.121 93.955 334.889 80.383 279.017 62.33 183.4 75.585 20.51 98.165-64.362 184.803-137.338 140.42c-40.128-24.406-64.669-81.136-48.761-103.736 34.158-48.53 217.973 112.638 473.523 108.058 233.32-4.18 251.403-141.599 475.689-143.718 226.76-2.141 245.44 137.972 501.695 148.04 232.694 9.144 426.896-98.152 443.183-61.593 6.454 14.485-19.273 42.026-42.26 58.352z">
                    </path>
                </svg>
            </section>
            {/* Transitioning Divider */}

            {/* Fourth Frame */}
            <section className="SectionFour">
                <div className="SectionContent">
                    <img src="https://res.cloudinary.com/dyjbpwees/image/upload/v1607200785/breeze/Featured2.png" />
                </div>
                <div className="FeatureSpotlightText">
                    <h1 className="header">
                        Discover
                    </h1>
                    <p className="headerPara2">
                        Don't miss out! Our discovery algorithm finds events that we think you will be interested in catered to your profile. Here, you can easily add events you are interested in to your Breeze calendar, as well as view the profile of the affiliate hosting the event to find out more.
                    </p>
                </div>
            </section>

            {/* Transitioning Divider */}
            <section>
                <svg className="divider4" viewBox="0 0 2000 242" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2000 75.463c-230.631 73.429-431.99 108.499-604.064 105.196-293.434-5.632-485.998-145.823-954.537-150.568C272.956 28.385 125.825 50.689 0 96.996V242h2000V75.463z">
                    </path>
                </svg>
            </section>
            {/* Transitioning Divider */}

            {/* Fifth Frame */}
            <section className="SectionFive">
                <h1 className="headerOne">
                    Don't let your opportunities
                </h1>
                <h1 className="headerTwo">
                    drift away
                </h1>
                <div className="RegisterPics">
                    {/* <img className="Group" src="https://res.cloudinary.com/dyjbpwees/image/upload/v1604381834/breeze/noun_organization_2088554.png" />
          <hr className="divider"/>
          <img className="Individual" src="https://res.cloudinary.com/dyjbpwees/image/upload/v1604381146/breeze/noun_individual_2088520.png" /> */}
                    <div className="GroupContainer">
                        <img className="Group" src={process.env.PUBLIC_URL + '/digitalassets/affiliates.png'} />
                        <p className="GroupParagraph"> For Campus Affiliated Clubs and Organizations</p>
                        <AFSignupModal />
                    </div>
                    <hr className="divider" />
                    <div className="IndividualContainer">
                        <img className="Individual" src={process.env.PUBLIC_URL + '/digitalassets/individual.png'} />
                        <p className="IndividualParagraph"> For Current Students and Prospects</p>
                        <SignupModal />
                    </div>
                </div>
            </section>
        </div>
    );
}

class Home extends Component {
    constructor(props) {
        super(props);
    }


    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        return (
            <Router>
                {/* {fire != null ? <Redirect to="/Profile" /> : <Redirect to="/" />} */}
                {firebase.auth().currentUser && <Redirect to="/Profile" /> }
                {!firebase.auth().currentUser && <Redirect to="/" />}
                <Switch>
                    <Route path="/" exact component={mainPage} />
                    <Route path="/ProfileSettings" exact component={ProfileSettings} />
                    <Route path="/Profile" exact component={Eventfeed} />
                    <Route path="/Explore" exact component={Search} />
                    <Route path="/Discovery" exact component={Discovery} />
                    <Route path="/Affiliate/" component={AffiliateView} />
                    <Route path="/AffiliateEvents/" component={AffiliateEvents} />
                    <Route path="/AffiliateGallery/" component={AffiliateGallery} />
                    <Route path="/Calendar" exact component={CalendarPage} />
                </Switch>
            </Router>

        );
    }
}

export default Home;